import { forwardRef, useEffect, useState } from "react";
import { IconButton, TextField } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { t } from "i18next";
import api from "../../../../helpers/api/LoginApi";
import ApiUrls from "../../../../helpers/urls/ApiUrls";
import AppConfig from "../../../../helpers/constants/AppConfig";
import LoadingProgress from "../../../../components/LoadingProgress";
import { appendFormData } from "../../../../helpers/functions/form-append";
import "./captcha.css";

const Captcha = forwardRef(({ onKeyPress, errors, setErrors, setLoading, checkCaptcha, loginFormCheck, login, showSnackbar }, ref) => {
  const [formData, setFormData] = useState({
    token: null,
    code: ''
  });
  const { token, code } = formData;
  const [loadingImg, setLoadingImg] = useState(false);

  useEffect(() => {
    getCaptcha();
  }, []);

  const getCaptcha = () => {
    setLoadingImg(true);

    api.get(ApiUrls.auth.get_captcha)
      .then((response) => {
        setLoadingImg(false);
        if (response.data) {
          if (response.data.status === "success") {
            setFormData({
              ...formData,
              token: response.data.token,
            });
          } else if (response.data.status === "user not found") {
            showSnackbar("خطا در دریافت تصویر امنیتی");
          }
        }
      })
      .catch((error) => {
        setLoadingImg(false);
        showSnackbar("خطا در دریافت تصویر امنیتی");
      });
  }

  useEffect(() => {
    if (checkCaptcha) {
      checkInputs();
    }
  }, [checkCaptcha]);

  const handleChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: null
    });
  };

  const checkInputs = () => {
    let temp_errors = {};

    if (code === "") {
      temp_errors.code = t("message.auth_required", { item: t("auth.captcha") });
    }

    loginFormCheck(temp_errors, checkCaptchaCode);
  }

  const checkCaptchaCode = () => {
    setLoading(true);

    const postFormData = appendFormData(formData);

    api.post(ApiUrls.auth.check_captcha, postFormData)
      .then((response) => {
        let res = response.data;
        if (res.status === "success") {
          checkResult(res.result);
        } else {
          setLoading(false);
          showSnackbar("خطای کد امنیتی!");
        }
      })
      .catch((error) => {
        setLoading(false);
        showSnackbar("خطای کد امنیتی!");
      });
  }

  const checkResult = (res) => {
    switch (res) {
      case -2:
      case -3:
        setLoading(false);
        setErrors({ code: "کد امنیتی وارد شده صحیح نمی‌باشد." });
        break;
      case -1:
        setLoading(false);
        setErrors({ code: "کد امنیتی منقضی شده است." });
        break;
      case 1:
        login();
        break;
      default:
        setLoading(false);
        showSnackbar("خطای کد امنیتی!");
    }
  }

  return (
    <div className="d-flex flex-column mt-4 captcha">
      {loadingImg
        ? <LoadingProgress />
        : (
          <div className="d-flex">
            <IconButton onClick={getCaptcha} >
              <Refresh />
            </IconButton>
            {token &&
              <img
                src={`${AppConfig.api_baseURL}captcha/${token}.png`}
                style={{ width: '95%' }}
                alt="captcha"
                key={token}
              />
            }
          </div>
        )
      }

      <TextField id="code" label={t("auth.captcha")} variant="outlined" fullWidth
                 value={code} className="ltr-textfield mt-3"
                 inputRef={ref} error={errors?.code} helperText={errors?.code}
                 onKeyPress={(e) => e.key === 'Enter' && checkInputs()}
                 onChange={(e) => handleChange(e.target.value, "code")} />
    </div>
  )}
)

export default Captcha;
